import {createSiteAdminKey, getSiteCredentials, revealSiteAdminKey, revokeSiteAdminKey, rotateSiteAdminKey} from '@/api/site-credentials';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import type {SiteId} from '@/types/api';

export function useSiteCredentials(siteId?: SiteId) {
    return useQuery({
        queryKey: ['siteCredentials', siteId],
        queryFn: () => getSiteCredentials(siteId!),
        enabled: Boolean(siteId)
    });
}

export function useRevealSiteAdminKey() {
    return useMutation({mutationFn: revealSiteAdminKey});
}

function useCredentialMutation<T>(mutationFn: (siteId: SiteId) => Promise<T>) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn,
        onSuccess: (_, siteId) => queryClient.invalidateQueries({queryKey: ['siteCredentials', siteId]})
    });
}

export function useRotateSiteAdminKey() {
    return useCredentialMutation(rotateSiteAdminKey);
}

export function useRevokeSiteAdminKey() {
    return useCredentialMutation(revokeSiteAdminKey);
}

export function useCreateSiteAdminKey() {
    return useCredentialMutation(createSiteAdminKey);
}
